var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72386 10.0007H2.66667C2.29848 10.0007 2 9.70221 2 9.33402V6.66735C2 6.29916 2.29848 6.00069 2.66667 6.00069H3.72386L6.86193 2.86261C7.28191 2.44264 8 2.74008 8 3.33402V12.6674C8 13.2613 7.28191 13.5587 6.86193 13.1388L3.72386 10.0007Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 9.33268L12.6673 7.99935M12.6673 7.99935L14.0007 6.66602M12.6673 7.99935L11.334 6.66602M12.6673 7.99935L14.0007 9.33268",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.0d4203f562839bdd15eff041f6c1cec6.svg";
export { ForwardRef as ReactComponent };